import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { MessageService } from "primeng/api";

import { ProvideMenuService } from "../services/api/provide-menu.service";
import { filter } from "rxjs/operators";
import { element } from "protractor";

declare var $: any;

@Component({
  selector: "app-select-features",
  templateUrl: "./select-features.component.html",
  styleUrls: ["./select-features.component.scss"],
})
export class SelectFeaturesComponent implements OnInit {
  menus: any;
  features: any;
  selectedMenu: any[] = [];
  selectedFeatures: any[] = [];
  mappedFeatures: any;
  featureChkModel = [];
  allFeatureChkModel =[];
  allFeatureChk:boolean;
  currentSelectedMenu: any = {};
  constructor(
    private service: ProvideMenuService,
    private router: Router,
    private toast: MessageService
  ) {
    this.selectedFeatures = [];
  }
  getMenus() {
    this.service.getMenus().subscribe((res: any) => {
      this.menus = res;
    });
  }
  getFeatures() {
    this.service.getFeatures().subscribe((res: any) => {
      this.features = res;
    });
  }
  mapPermissions() {
    this.service.mappedPermissions().subscribe((res) => {
      this.mappedFeatures = res;
    });
  }

  onMenuCheck(menu, event) {
    this.features.forEach((element) => {
      
      this.featureChkModel[element.id] = false;
    });
    this.currentSelectedMenu = this.mappedFeatures.find((ele) => {
      return ele.id == menu.id;
    });

    if (this.currentSelectedMenu) {
      this.currentSelectedMenu.permissions = JSON.parse(
        JSON.stringify(this.currentSelectedMenu.permissionsMap)
      );
      this.currentSelectedMenu.permissions.forEach((element) => {
        this.featureChkModel[element.id] = true;
      });
    } else {
      this.currentSelectedMenu = menu;
      this.currentSelectedMenu.permissions = [];
      this.currentSelectedMenu.isEnabled = true;
    }
  }
  checkAllOptions(event){
    this.features.forEach(ele => {
      if(event==true){
        this.featureChkModel[ele.id] = true;
        this.onFeatureCheck(true,ele);
      }else{
        this.featureChkModel[ele.id] = false;
        this.onFeatureCheck(false,ele);
      }
    });
  }
  onFeatureCheck(event, feature: any) {
    
    if (event) {
      this.currentSelectedMenu.permissions.push(feature);
    } else {
      this.currentSelectedMenu.permissions = this.currentSelectedMenu.permissions.filter(
        (element) => {
          return element.id !== feature.id;
        }
      );
    }
  }
  setMenuFeature() {
    if (this.currentSelectedMenu) {
      var d = {
        id: this.currentSelectedMenu.id,
        isEnabled: this.currentSelectedMenu.isEnabled,
        permissionsMap: this.currentSelectedMenu.permissions,
      };
    }
    delete this.currentSelectedMenu.permissions;
    this.service.mapPermissions(d).subscribe((res) => {
      this.router.navigateByUrl("/", { skipLocationChange: true }).then(() => {
        this.router.navigate(["/provide-menu/select-feature"]);
      });
      this.mapPermissions();
      setTimeout(() => {
        this.toast.add({
          severity: "success",
          summary: "Success",
          detail: "Menu Updated Successfully!!!",
        });
      }, 100);
    });
  }
  ngOnInit() {
    this.getMenus();
    this.getFeatures();
    this.mapPermissions();
  }
}
